import React from "react";
import NotFound from "../assets/static/images/404.gif";
import { Link } from "react-router-dom";
import "../assets/styles/components/PageNotFound.scss";
const PageNotFound = () => {
  return (
    <div className="pageNotFound-container">
      <img className="pageNotFound-img" src={NotFound} alt="Not Found" />
      <Link to="/">Go to Home </Link>
    </div>
  );
};

export default PageNotFound;
